<template>
  <div class="newsDetails">
    <div class="news_detail">
      <div class="news_detail_left">
        <iframe :src="news_url"  frameborder="no" id="bdIframe"></iframe>
        <div class="news_shang" v-if="up" @click="getDetail(up_id)">上一篇：{{up}}</div>
        <div class="news_next" v-if="down" @click="getDetail(down_id)">下一篇：{{down}}</div>
      </div>
      <div class="news_detail_right">
        <div class="news_detail_right_title">热门推荐</div>
        <div class="news_detail_right_newlist">
          <div class="news_detail_right_newinfo" @click="getDetail(items.cms_id)"  v-for="(items,index) in hot_newslist" :key="index">
            {{items.cms_title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail, getRedRecommendNew } from "../../api/api";
export default {
  name: "NewsDetail",
  inject: ['reload'],
  data() {
    return {
      news_id: "",
      ticket:"",
      newsDetail:'',
      up:"",
      down:"",
      up_id:"",
      down_id:"",
      news_url:"",
      hot_newslist:[]
    };
  },
  mounted() {
    this.$store.commit("settab", 1);
    this.news_id = this.$route.params.id;
    this.ticket = localStorage.getItem("ticket");
    
    this.news_url = "http://api.danjiguanjia.com/v4/news/viewdetail/id/"+ this.news_id + '?ticket=' + this.ticket

    getNewsDetail({
      id: this.news_id,
      ticket: this.ticket
    }).then(res => {
      this.newsDetail = res.data
      this.up = res.data.pages.up.title
      this.down = res.data.pages.down.title
      this.up_id = res.data.pages.up.id
      this.down_id = res.data.pages.down.id
      //console.log(res.data)
    })

    getRedRecommendNew({}).then(res => {
      this.hot_newslist = res.data
    })

    /**
     * iframe-宽高自适应显示   
     */
    const oIframe = document.getElementById('bdIframe');
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = 100 + '%'; //数字是页面布局宽度差值
    oIframe.style.height = 85 + '%'; //数字是页面布局高度差
  },
  methods: {
    getDetail(id){
      this.reload();
      this.$router.push({path:'/NewsDetail/'+ id})
    }
  }
};
</script>

<style>
.newsDetails {
  margin: 30px 0 80px 0;
  background: #eeeeee;
}
.news_detail {
  width: 1410px;
  display: flex;
  margin: 0 auto;
}
.news_detail_left {
  margin: 12px 0;
  width: 1151px;
  background: #ffffff;
  height: 1000px;
}
.news_detail_left iframe{
  width: 90%;
  height: 100%;
}
.news_shang{
  margin-top: 66px;
  margin-left: 10px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.news_next{
  margin-top: 13px;
  margin-left: 10px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.news_detail_right {
  margin: 12px 0;
  width: 400px;
  /* height: 1115px; */
  background: #ffffff;
  margin-left: 10px;
}
.news_detail_right_title {
  font-size: 24px;
  margin-left: 14px;
  margin-top: 26px;
  color: #000000;
}
.news_detail_right_newlist{
  margin: 40px 25px 40px 25px;
}
.news_detail_right_newinfo{
  height: 20px;
  line-height: 20px;
  margin-bottom: 20px;
  font-size: 20px;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/news/NewsDetail.vue